// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ZFyoZ","text":"style_text__XQ0Vj"};